(function () {
  var instances = new WeakMap();

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function init(root) {
    if (!root || instances.has(root)) return;

    var cleanups = [];
    var rootStyle = window.getComputedStyle(root);
    document.documentElement.classList.add("skv2-password-active");
    document.documentElement.style.setProperty("--sk-password-bg", rootStyle.getPropertyValue("--sk-ink").trim() || "#20131a");

    initCountdown(root, cleanups);
    initAnchors(root, cleanups);
    initClues(root, cleanups);
    initMobileCta(root, cleanups);
    initForm(root, cleanups);

    instances.set(root, function () {
      cleanups.forEach(function (cleanup) { cleanup(); });
      instances.delete(root);
    });
  }

  function initCountdown(root, cleanups) {
    var countdown = root.querySelector("[data-skv2-countdown]");
    if (!countdown) return;

    var launchTime = Date.parse(countdown.getAttribute("data-skv2-countdown") || "");
    var status = root.querySelector("[data-skv2-countdown-status]");
    var days = countdown.querySelector("[data-skv2-days]");
    var hours = countdown.querySelector("[data-skv2-hours]");
    var minutes = countdown.querySelector("[data-skv2-minutes]");
    var seconds = countdown.querySelector("[data-skv2-seconds]");
    var timer = null;

    function setZero(message) {
      if (days) days.textContent = "00";
      if (hours) hours.textContent = "00";
      if (minutes) minutes.textContent = "00";
      if (seconds) seconds.textContent = "00";
      if (status) status.textContent = message;
    }

    if (!Number.isFinite(launchTime)) {
      setZero("Fecha de lanzamiento pendiente de confirmar.");
      countdown.dataset.skv2Invalid = "true";
      return;
    }

    function renderCountdown() {
      var diff = launchTime - Date.now();
      if (diff <= 0) {
        setZero("El acceso privado ya está disponible.");
        stop();
        return;
      }

      var dayValue = Math.floor(diff / 86400000);
      var hourValue = Math.floor((diff % 86400000) / 3600000);
      var minuteValue = Math.floor((diff % 3600000) / 60000);
      var secondValue = Math.floor((diff % 60000) / 1000);

      if (days) days.textContent = pad(dayValue);
      if (hours) hours.textContent = pad(hourValue);
      if (minutes) minutes.textContent = pad(minuteValue);
      if (seconds) seconds.textContent = pad(secondValue);
      if (status) status.textContent = "Faltan " + dayValue + " días, " + hourValue + " horas y " + minuteValue + " minutos.";
    }

    function start() {
      stop();
      renderCountdown();
      timer = window.setInterval(renderCountdown, 1000);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function handleVisibility() {
      if (document.hidden) stop();
      else start();
    }

    document.addEventListener("visibilitychange", handleVisibility);
    cleanups.push(function () {
      stop();
      document.removeEventListener("visibilitychange", handleVisibility);
    });
    start();
  }

  function initAnchors(root, cleanups) {
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var mobileViewport = window.matchMedia("(max-width: 640px)");

    function scrollToTarget(target) {
      var behavior = reduceMotion.matches ? "auto" : "smooth";

      if (mobileViewport.matches && target.hasAttribute("data-skv2-form-anchor")) {
        var rect = target.getBoundingClientRect();
        var viewport = window.visualViewport;
        var viewportHeight = viewport ? viewport.height : window.innerHeight;
        var viewportOffsetTop = viewport ? viewport.offsetTop : 0;
        var centeredTop = window.pageYOffset + rect.top - viewportOffsetTop - ((viewportHeight - rect.height) / 2);

        window.scrollTo({
          top: Math.max(0, centeredTop),
          behavior: behavior
        });
        return;
      }

      target.scrollIntoView({
        behavior: behavior,
        block: "start"
      });
    }

    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      function handleClick(event) {
        var selector = link.getAttribute("href");
        if (!selector || selector === "#") return;

        var target = root.querySelector(selector) || document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        scrollToTarget(target);
      }

      link.addEventListener("click", handleClick);
      cleanups.push(function () { link.removeEventListener("click", handleClick); });
    });
  }

  function initClues(root, cleanups) {
    root.querySelectorAll("[data-skv2-clue]").forEach(function (button) {
      function activate() {
        var card = button.closest(".skv2-clue-card");
        if (!card) return;

        root.querySelectorAll(".skv2-clue-card").forEach(function (otherCard) {
          otherCard.classList.remove("is-active");
          var otherButton = otherCard.querySelector("[data-skv2-clue]");
          if (otherButton) otherButton.setAttribute("aria-expanded", "false");
        });

        card.classList.add("is-active");
        button.setAttribute("aria-expanded", "true");
      }

      button.addEventListener("click", activate);
      cleanups.push(function () { button.removeEventListener("click", activate); });
    });
  }

  function initMobileCta(root, cleanups) {
    var mobileCta = root.querySelector("[data-skv2-mobile-cta]");
    var formAnchor = root.querySelector("[data-skv2-form-anchor]");
    if (!mobileCta || !formAnchor || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mobileCta.classList.toggle("is-hidden", entry.isIntersecting);
      });
    }, { threshold: 0.18 });

    observer.observe(formAnchor);
    cleanups.push(function () { observer.disconnect(); });
  }

  function initForm(root, cleanups) {
    root.querySelectorAll("form.skv2-form").forEach(function (form) {
      function handleSubmit(event) {
        var honeypot = form.querySelector(".skv2-honeypot");
        if (honeypot && honeypot.value) {
          event.preventDefault();
          return;
        }

        var submit = form.querySelector("[data-skv2-submit]");
        if (submit) {
          submit.disabled = true;
          submit.dataset.originalText = submit.textContent;
          submit.textContent = "Enviando...";
        }
      }

      form.addEventListener("submit", handleSubmit);
      cleanups.push(function () { form.removeEventListener("submit", handleSubmit); });
    });
  }

  function destroy(root) {
    var cleanup = instances.get(root);
    if (cleanup) cleanup();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-skv2-section]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-skv2-section]").forEach(destroy);
  });
})();